// removed by extract-text-webpack-plugin
module.exports = {"benchmarkKey":"CompareDriversGraph__benchmarkKey___3Hcfx","benchmarkLabel":"CompareDriversGraph__benchmarkLabel___SAQhw","benchmarkDash":"CompareDriversGraph__benchmarkDash___30ysM"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/CompareDriversGraph.css
// module id = 1540
// module chunks = 0